import React from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId")

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-primary text-white px-6">
      {/* Animated 404 Text */}
      <h1 className="text-8xl md:text-9xl font-bold animate-bounce">404</h1>

      {/* Page Not Found Text */}
      <h2 className="text-2xl md:text-4xl font-semibold mt-4">
        Oops! Page Not Found
      </h2>

      {/* Message */}
      <p className="text-lg md:text-xl text-gray-300 mt-2 text-center max-w-lg">
        The page you’re looking for doesn’t exist or has been moved.
      </p>

      {/* CTA Button */}
      <button
        onClick={() => {
          if (userId) {
            navigate("/login");
          } else navigate("/")
        }}
        className="mt-6 px-6 py-3 bg-[#FF6005] text-white text-lg font-semibold rounded-lg shadow-md hover:bg-orange-600 transition duration-300"
      >
        Go Back Home
      </button>

      {/* Decorative Circle */}
      <div className="absolute top-20 right-10 h-16 w-16 bg-[#FF6005] opacity-30 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 left-10 h-24 w-24 bg-[#FF6005] opacity-20 rounded-full blur-2xl"></div>
    </div>
  );
}

export default NotFound;
